module.exports = __webpack_public_path__ + "static/media/programming.e7fd0478.svg";